import { SHARED_PREFERENCE } from "core-lib/constants/nativeBridge";
import { PLATFORM } from "core-lib/data/common";
import {
  isValidMobileVersion,
  passMessageToNative,
  waitForCustomEvent,
} from "./nativeBridge";

export function setValueInNativeSession(key, value, isSessionBased = true) {
  passMessageToNative(SHARED_PREFERENCE, null, {
    action: "save",
    key,
    value,
    isSessionBased: true,
  });
}

// export const isNativeSessionStorageAvailable = () =>
//   isValidMobileVersion({
//     version: "3.4.11",
//     platform: PLATFORM.ios,
//   }) ||
//   isValidMobileVersion({
//     version: "6.2.33",
//     platform: PLATFORM.android,
//   });

export const isNativeSessionStorageAvailable = () =>
  isValidMobileVersion({
    version: "6.2.33",
    platform: PLATFORM.android,
  });

export async function getValueFromNativeSession(
  key,
  isSessionBased = true
): Promise<{
  response: any;
  error: string;
}> {
  const script = `
    try{
        const value = "__value__";
        window.dispatchEvent(new CustomEvent('nativeGetValueFromSession', {  detail: {res : value} }));
        } catch(e){
          console.error('callback_script error',e);
        }`;
  passMessageToNative(SHARED_PREFERENCE, null, {
    action: "get",
    key,
    isSessionBased,
    callback_script: script,
  });
  const eventResult: any = await waitForCustomEvent(
    "nativeGetValueFromSession"
  );

  if (eventResult?.detail) {
    return {
      response: eventResult.detail.res,
      error: null,
    };
  }
}
